import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import featureFlags from '#/shared/feature-flags';
import GTM_HANDLES from '#/shared/gtm-handles';
import * as Styled from './styled';

const { mapLibre } = featureFlags;
// TODO: PRJ77-785 - Include data for BIKETOWN Hubs (i.e. available bikes and docks)
function ContextMenuPopup({
  popupLocation,
  setCurrentLocation,
  clearManualLocation,
  seeServiceNearby,
  planTripToHere,
  planTripFromHere,
  isMobile,
  geoLocationApproved,
  isManualLocation,
  resetPopupLocation,
}) {
  const showSetManualLocationButton =
    !isMobile && !geoLocationApproved && !isManualLocation;
  const showClearLocationButton = isManualLocation;
  const popupContents = () => (
    <Styled.ContextMenuWrapper>
      {showClearLocationButton && (
        <Styled.ContextMenuRow
          onClick={clearManualLocation}
          data-gtm={GTM_HANDLES.map.contextClearCurrentLocation}
        >
          <Styled.IconColumn>
            <Styled.ClearCurrentLocationMarker />
          </Styled.IconColumn>
          <Styled.ContentColumn>
            <FormattedMessage id="map.clearcurrentlocation" />
          </Styled.ContentColumn>
        </Styled.ContextMenuRow>
      )}

      {showSetManualLocationButton && (
        <Styled.ContextMenuRow
          onClick={setCurrentLocation}
          data-gtm={GTM_HANDLES.map.contextSetCurrentLocation}
        >
          <Styled.IconColumn>
            <Styled.CurrentLocationMarker />
          </Styled.IconColumn>
          <Styled.ContentColumn>
            <FormattedMessage id="map.setcurrentlocation" />
          </Styled.ContentColumn>
        </Styled.ContextMenuRow>
      )}
      <Styled.ContextMenuRow
        onClick={seeServiceNearby}
        data-gtm={GTM_HANDLES.map.contextSeeNearbyService}
      >
        <Styled.IconColumn>
          <Styled.SelectedLocationIcon />
        </Styled.IconColumn>
        <Styled.ContentColumn>
          <FormattedMessage id="map.see-service-nearby" />
        </Styled.ContentColumn>
      </Styled.ContextMenuRow>
      <Styled.PlanTripRowWrapper>
        <Styled.TripButton
          onClick={planTripToHere}
          data-gtm={GTM_HANDLES.map.contextGoHere}
        >
          <FormattedMessage id="map.go-here" />
        </Styled.TripButton>
        <Styled.Separator />
        <Styled.TripButton
          onClick={planTripFromHere}
          data-gtm={GTM_HANDLES.map.contextStartHere}
        >
          <FormattedMessage id="map.start-here" />
        </Styled.TripButton>
      </Styled.PlanTripRowWrapper>
    </Styled.ContextMenuWrapper>
  );

  if (mapLibre) {
    return (
      <Styled.ContextMenuWrapper>
        {popupLocation && (
          <Styled.MapGlPopup
            latitude={popupLocation[0]}
            longitude={popupLocation[1]}
            onClose={resetPopupLocation}
            focusAfterOpen={false}
          >
            {popupContents()}
          </Styled.MapGlPopup>
        )}
      </Styled.ContextMenuWrapper>
    );
  }
  return <>{popupContents()}</>;
}

ContextMenuPopup.propTypes = {
  /** Array of coordinates for the MapLibre version of the popup */
  popupLocation: PropTypes.arrayOf(PropTypes.number).isRequired,
  /** Method that communicates to RMGLMapContainer to dismiss the MapLibre popup */
  resetPopupLocation: PropTypes.func.isRequired,
  /** Sets the current location */
  setCurrentLocation: PropTypes.func.isRequired,
  /** Clears the current location */
  clearManualLocation: PropTypes.func.isRequired,
  /** Shows nearby service (does not set current location) */
  seeServiceNearby: PropTypes.func.isRequired,
  /** Plan trip to here */
  planTripToHere: PropTypes.func.isRequired,
  /** Plan trip from here */
  planTripFromHere: PropTypes.func.isRequired,
  /** Boolean to whether or not the user is using a mobile device */
  isMobile: PropTypes.bool,
  /** Is true or false based on whether the user has given access to their devcies location */
  geoLocationApproved: PropTypes.bool,
  /** Is true or false if manualLocation is set */
  isManualLocation: PropTypes.bool,
};

ContextMenuPopup.defaultProps = {
  isMobile: null,
  geoLocationApproved: false,
  isManualLocation: false,
};

export default ContextMenuPopup;
